import type { ReactNode } from 'react';
import { HashRouter, Navigate, Route, Routes } from 'react-router-dom';
import { AppServices, useServices } from './app/services.jsx';
import { LibraryView } from './views/LibraryView.jsx';
import { OnboardingView } from './views/OnboardingView.jsx';
import { ReaderView } from './views/ReaderView.jsx';
import { SettingsView } from './views/SettingsView.jsx';

function RootRedirect(): ReactNode {
  const { settings } = useServices();
  return <Navigate to={settings.onboardingComplete ? '/library' : '/onboarding'} replace />;
}

export function App(): ReactNode {
  return (
    <AppServices>
      <HashRouter>
        <Routes>
          <Route path="/" element={<RootRedirect />} />
          <Route path="/onboarding" element={<OnboardingView />} />
          <Route path="/library" element={<LibraryView />} />
          <Route path="/read/:id" element={<ReaderView />} />
          <Route path="/settings" element={<SettingsView />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </HashRouter>
    </AppServices>
  );
}
